<template>
  <div
    :class="{ 'ticket-choice-wrapper': true, highlight: highlight }"
    :title="safeLabel"
    @click="sendClick"
  >
    <div
      class="category"
      v-text="safeLabel"
    />
    <img
      class="img"
      :src="validImgSrc"
      :alt="imgAlt"
    >
    <md-tooltip
      v-if="tooltip"
      md-direction="top"
    >
      <p>{{ tooltip }}</p>
    </md-tooltip>
  </div>
</template>

<script>
import { isValidUrl } from "../../util/is-valid-url";
import { unescapeHtml } from "../../util/unescape-html";

export default {
  name: "NewTicketChoice",
  props: {
    label: {
      type: String,
      default: () => "",
    },
    icon: {
      type: String,
      default: () => "",
    },
    tooltip: {
      type: String,
      default: () => undefined,
    },
    highlight: {
      type: Boolean,
      default: () => false,
    }
  },
  computed: {
    safeLabel() {
      return unescapeHtml(this.label);
    },
    validImgSrc() {
      return this.icon && isValidUrl(this.icon)
        ? this.icon
        : require("../../assets/img/not-found.png");
    },
    imgAlt() {
      return `Ícone de ${this.safeLabel}`;
    },
  },
  methods: {
    sendClick() {
      this.$emit("click");
    },
  }
};
</script>
<style scoped lang="scss">
@use 'sass:math';

.ticket-choice-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;

  border-radius: 5px;
  padding: 10px;

  width: math.div(96.5%, 2);

  @media (min-width: 960px) {
    width: math.div(93%, 4);
  }

  @media (min-width: 1280px) {
    width: math.div(85%, 8);
  }

  box-shadow: 0 1px 4px 0 rgba(0 0 0 / .2);

  transform: scale(1);
  transition:
    transform 100ms ease-in-out,
    box-shadow 100ms ease-in-out,
    opacity 100ms ease-in-out;

  img {
    width: 75%;
  }

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 1px 6px 0 rgba(0 0 0 / .15);
    opacity: 1 !important;
  }

  &:not(.highlight) {
    opacity: 0.5;
  }

  .category {
    overflow: hidden;
    text-overflow: ellipsis;

    text-align: center;
    max-width: 100%;
    margin-bottom: 5px;

    @media (max-width: 1280px) {
      font-size: 1.3rem;
    }
  }

}
</style>
